module.exports = __webpack_public_path__ + "img/2.8dc38206.jpg";